/**
 * An object representing the possible sorting orders.
 */
export const ORDER = {
    /** Represents ascending order. */
    asc: 'asc',
    /** Represents descending order. */
    desc: 'desc',
} as const;

/**
 * An object that defines the possible sorting criteria for specific operations.
 */
export const SORT_BY = {
    /** Represents sorting based on the starting criteria.*/
    starts: 'starts',
    /** Represents sorting based on the ending criteria.*/
    ends: 'ends',
} as const;

/**
 * An object representing the statuses associated with a reservation.
 */
export const RESERVATION_STATUS = {
    /** Represents all reservation statuses. */
    all: 'all',
    /** Represents a reservation that is valid. */
    valid: 'valid',
    /** Represents a reservation that is invalid. */
    invalid: 'invalid',
    /** Represents a reservation that is cancelled. */
    cancelled: 'cancelled',
    /** Represents a reservation that has been completed. */
    completed: 'completed',
} as const;

/**
 * An object representing the types of reservations.
 */
export const RESERVATION_TYPE = {
    /** Represents all reservation types. */
    all: 'all',
    /** Represents a reservation that is monthly rates. */
    monthly: 'monthly',
    /** Represents a reservation that is for trancient rates. */
    transient: 'transient',
    /** Represents a reservation that is for event rates. */
    event: 'event',
} as const;

/**
 * An object representing the possible reservation scopes.
 */
export const RESERVATION_SCOPE = {
    all: 'all',
};
